import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import moment from 'moment';
let CreditTopUpMixin = class CreditTopUpMixin extends Vue {
    goToTopUp(app) {
        const timestamp = moment().unix();
        let uuid = `${app.uuid}${timestamp}:grab_express`;
        if (app.grabExpressKey) {
            uuid = `${app.grabExpressKey}:grab_express`;
        }
        this.$router.push({
            name: 'ecommerce-shipping-top-up',
            params: {
                uuid,
            },
        });
    }
};
CreditTopUpMixin = __decorate([
    Component
], CreditTopUpMixin);
export default CreditTopUpMixin;
